import { useEffect, useRef } from 'react';

/**
 * 앱이 포그라운드로 복귀할 때 데이터를 Refetch하는 커스텀 훅.
 * @param {Function} callback 데이터 로드 함수
 * @param {number} cooldownMs 중복 호출 방지 쿨다운 시간 (기본값 5초)
 */
export const useForegroundRefetch = (callback, cooldownMs = 5000) => {
  const lastRefetchTime = useRef(0);
  const callbackRef = useRef(callback);

  useEffect(() => {
    callbackRef.current = callback;
  }, [callback]);

  useEffect(() => {
    const handleVisibilityChange = () => {
      if (document.visibilityState === 'visible') {
        const now = Date.now();
        if (now - lastRefetchTime.current >= cooldownMs) {
          lastRefetchTime.current = now;
          if (callbackRef.current) {
            callbackRef.current();
          }
        }
      }
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);
    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, [cooldownMs]);
};
